import React from 'react';
import {
  IconInstallationCreated,
  IconIntegration,
  IconIntegrationController,
  IconJoin,
  IconMigration,
  IconNoInstallation,
  IconSent,
  IconShare,
  IconUpdate,
  IconWait,
} from '../../assets/status-screen-icons';
import { StatusTypeEnum } from '../../types';

type StatusIconProps = {
  type: StatusTypeEnum;
};

export const StatusIcon: React.FC<StatusIconProps> = ({ type }) => {
  switch (type) {
    case StatusTypeEnum.NO_INSTALLATION:
      return <IconNoInstallation />;
    case StatusTypeEnum.INTEGRATION:
      return <IconIntegration />;
    case StatusTypeEnum.SENT:
      return <IconSent />;
    case StatusTypeEnum.JOIN:
      return <IconJoin />;
    case StatusTypeEnum.UPDATE:
      return <IconUpdate />;
    case StatusTypeEnum.WAIT:
      return <IconWait />;
    case StatusTypeEnum.SHARE:
      return <IconShare />;
    case StatusTypeEnum.INTEGRATION_CONTROLLER:
      return <IconIntegrationController />;
    case StatusTypeEnum.INSTALLATION_CREATED:
      return <IconInstallationCreated />;
    case StatusTypeEnum.MIGRATION:
      return <IconMigration />;
    default:
      return null;
  }
};
